export default __webpack_public_path__ + "static/media/grey.a0a33e02.webp";